import React from 'react'
import {
  Form,
  Button,
} from 'components/atoms'
import { Formik, Field } from 'formik';
import { FieldCustom } from 'components/molecules';
import PropTypes from 'prop-types'
import * as Yup from 'yup';
import styled from 'styled-components/macro';

const Schema = Yup.object().shape({
  title: Yup.string()
    .min(2, 'Mínimo de 4 caracteres')
    .max(50, 'Máximo de 50 caracteres')
    .required('Campo obrigatório'),
});


const SideNavEditorParentForm = ({
  initialValues, onChange, onSubmit, onDiscard
}) => {
  // when the values change Formik runs validate so we can values changing side effects here
  // update the page json by invoking onChange(newProps)
  const handleFormChange = (newValues) => {
    onChange(newValues)
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={Schema}
      validate={handleFormChange}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      enableReinitialize
    >
      <Form>
        <Field
          title="Título"
          name="title"
          info="Título do item de menu."
          component={FieldCustom}
          maxLetters={50}
        />
        <Actions>
          {typeof onDiscard === 'function' && (
            <Button type="button" modifiers={['marginRight', 'capitalize']} onClick={onDiscard}>
              Cancelar
            </Button>
          )}
          <Button
            type="submit"
            modifiers={['primary', 'capitalize']}
          >
              Adicionar
          </Button>
        </Actions>
      </Form>
    </Formik>
  )
}

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.l};
`;

SideNavEditorParentForm.defaultProps = {
  initialValues: {
    title: '',
  },
  onSubmit: () => {},
  onDiscard: null,
  onChange: () => {}
}

SideNavEditorParentForm.propTypes = {
  initialValues: PropTypes.shape({
    title: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onDiscard: PropTypes.func,
  onSubmit: PropTypes.func,
}


export default SideNavEditorParentForm
